import Vue from 'vue';
import SITE from '@/config/site';
import { translate, translateTriple } from '@/i18n';

Vue.prototype.$site = SITE;

Vue.prototype.$t = function t(key, params) {
  return translate(this.$store.state.language, key, params);
};

/** English, Myanmar, Malay — for Setting and legacy screens */
Vue.prototype.$lang = function lang(en, mm, ms) {
  return translateTriple(this.$store.state.language, en, mm, ms);
};

Vue.mixin({
  computed: {
    useLatinContent() {
      return this.$store.state.language === 'en' || this.$store.state.language === 'ms';
    },
  },
  methods: {
    pickLocalized(mmValue, enValue) {
      return this.useLatinContent ? enValue : mmValue;
    },
  },
});
